"use client";

import { cn } from "@/lib/utils";
import React, { useState } from "react";

type ShowMorePropsType = {
  open?: boolean;
  allowedContentLength: number;
  content: string;
  className?: string;
  contentClassName?: string;
  buttonClassName?: string;
};

const ShowMore = ({
  open,
  allowedContentLength,
  content,
  className,
  contentClassName,
  buttonClassName,
}: ShowMorePropsType) => {
  const [showMore, setShowMore] = useState(open ?? false);

  return (
    <div className={cn("w-full", className)}>
      <pre
        className={cn(
          "w-full overflow-auto whitespace-break-spaces text-pretty break-words rounded-xl border bg-white p-3 font-sans text-xs text-slate-600 dark:border-neutral-700/50 dark:bg-neutral-800/50 dark:text-slate-400 md:text-sm",
          contentClassName,
        )}
      >
        &quot;
        {content.length <= allowedContentLength || showMore
          ? content
          : `${content.slice(0, allowedContentLength)}...`}
        &quot;
      </pre>
      {!(content.length <= allowedContentLength) && (
        <button
          aria-label={showMore ? "Show less" : "Show more"}
          type="button"
          onClick={() => setShowMore((prev) => !prev)}
          className={cn(
            "rounded-full border bg-white px-2 text-xs text-neutral-500 dark:bg-neutral-800/50",
            buttonClassName,
          )}
        >
          {showMore ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};

export default ShowMore;
